import React from 'react';
import DocumentList from '../components/DocumentList';

export default function ProformaInvoicesList() {
  return (
    <DocumentList
      apiPath="proforma-invoices"
      numberField="pi_number"
      title="Proforma Invoices"
      createPath="/create-proforma-invoice"
      viewPath="/proforma-invoice"
      editPath="/edit-proforma-invoice"
    />
  );
}
